// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Algorithm__container___lHXFI {
    display: flex;
    flex-direction: column;
    padding: 0.8rem 1.2rem;
}

.Algorithm__header___grtGK {
    margin-bottom: 0.8rem;
}

.Algorithm__input___x6Ss5 {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-end;

    padding-bottom: 0.8rem;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.Algorithm__input___x6Ss5 .Text {
    margin-right: 1.2rem;
}

/* stylelint-disable selector-class-pattern -- класс Consta */
.Algorithm__input___x6Ss5 .TextField,
.Algorithm__input___x6Ss5 .Select {
    width: 14rem;
}
/* stylelint-enable selector-class-pattern */

.Algorithm__methodSelect___RSYEX {
    margin-bottom: 1.6rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/modules/Modals/MachineLearningModal/RightMenu/Alghoritm/Algorithm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;;IAEzB,sBAAsB;AAC1B;;AAEA,uEAAuE;AACvE;IACI,oBAAoB;AACxB;;AAEA,6DAA6D;AAC7D;;IAEI,YAAY;AAChB;AACA,4CAA4C;;AAE5C;IACI,qBAAqB;AACzB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    padding: 0.8rem 1.2rem;\n}\n\n.header {\n    margin-bottom: 0.8rem;\n}\n\n.input {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    justify-content: flex-end;\n\n    padding-bottom: 0.8rem;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.input :global(.Text) {\n    margin-right: 1.2rem;\n}\n\n/* stylelint-disable selector-class-pattern -- класс Consta */\n.input :global(.TextField),\n.input :global(.Select) {\n    width: 14rem;\n}\n/* stylelint-enable selector-class-pattern */\n\n.methodSelect {\n    margin-bottom: 1.6rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Algorithm__container___lHXFI`,
	"header": `Algorithm__header___grtGK`,
	"input": `Algorithm__input___x6Ss5`,
	"methodSelect": `Algorithm__methodSelect___RSYEX`
};
export default ___CSS_LOADER_EXPORT___;
